import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import vueToastr from './plugins/vueToastr'
import vuehtmltopaper from './plugins/vuehtmltopaper'
import {i18n} from './plugins/i18n'
// Plugin de tutoriais em vídeo: registra this.$tutorial globalmente
// e monta o dialog de player fora da árvore de componentes do app
import TutorialPlugin from './plugins/tutorial'

Vue.use(TutorialPlugin)

Vue.config.productionTip = false
 
new Vue({
  router,
  store,
  vuetify,
  vueToastr,
  vuehtmltopaper,
  i18n,
  render: h => h(App)
}).$mount('#app')
